import React from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import 'primeicons/primeicons.css';
import StoreModal from "./StoreModal";
import "./ListModal.css";

class ListModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            selectedUser: null,
        };
    }

    incomeBodyTemplate = (rowData) => {
        const value = parseFloat(rowData.income);
        if (isNaN(value)) return rowData.income ?? '—';
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 });
    }

    genreBodyTemplate = (rowData) => {
        if (!rowData.genre) return '—';
        return rowData.genre.charAt(0).toUpperCase() + rowData.genre.slice(1);
    }

    actionBodyTemplate = (rowData) => {
        return (
            <Button
                icon="pi pi-pencil"
                className="p-button-text p-button-secondary"
                style={{ color: '#6c757d' }}
                onClick={() => this.setState({ show: true, selectedUser: rowData })}
            />
        );
    }

    renderHeaderContent = () => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span style={styles.title}>{this.props.selectedOverlay?.name}</span>
            </div>
        );
    }

    render() {

        return (
            <>

                <Dialog
                    header={this.renderHeaderContent}
                    visible={this.props.show}
                    modal
                    closable
                    onHide={this.props.onHide}
                    className="list-modal-dialog"
                    style={{ width: '60vw', marginTop: '2%' }}
                    contentStyle={{ padding: '0' }}
                >
                    <div className="p-4">
                        <DataTable
                            value={this.props.selectedOverlay?.meta_data_users}
                            responsiveLayout="scroll"
                            className="p-datatable-sm"
                            emptyMessage="Nenhum registro encontrado."
                            rowHover
                            style={{ border: 'none' }}
                            scrollable
                            scrollHeight="60vh"
                        >
                            <Column field="user_type" header="TIPO DE USUÁRIO" style={styles.column} headerStyle={styles.header}></Column>
                            <Column field="cep" header="CEP" style={{ ...styles.column, width: '150px', whiteSpace: 'nowrap' }} headerStyle={{ ...styles.header, width: '150px', whiteSpace: 'nowrap' }}></Column>
                            <Column field="age" header="IDADE" style={{ ...styles.column, width: '85px' }} headerStyle={{ ...styles.header, width: '85px' }}></Column>
                            <Column field="genre" header="GÊNERO" body={this.genreBodyTemplate} style={styles.column} headerStyle={styles.header}></Column>
                            <Column field="marital_status" header="ESTADO CIVIL" style={styles.column} headerStyle={styles.header}></Column>
                            <Column field="children" header="FILHOS" style={{ ...styles.column, width: '85px' }} headerStyle={{ ...styles.header, width: '85px' }}></Column>
                            <Column field="income" header="RENDA" body={this.incomeBodyTemplate} style={{ ...styles.column, width: '130px' }} headerStyle={{ ...styles.header, width: '130px' }}></Column>
                            <Column field="property_of_interest" header="EMPREENDIMENTO" style={styles.column} headerStyle={styles.header}></Column>
                            <Column field="typology_of_interest" header="TIPOLOGIA DE INTERESSE" style={styles.column} headerStyle={styles.header}></Column>
                            <Column body={this.actionBodyTemplate} header="AÇÕES" style={{ ...styles.column, width: '80px' }} headerStyle={{ ...styles.header, width: '80px' }}></Column>
                        </DataTable>
                    </div>
                </Dialog>

                <StoreModal
                    show={this.state.show}
                    user={this.state.selectedUser}
                    toast={this.props.toast}
                    reloadBuildings={this.props.reloadBuildings}
                    onHide={() => this.setState({ show: false, selectedUser: null })}
                />
            </>
        );
    }
}

const styles = {
    title: {
        fontFamily: '"Archivo Expanded", sans-serif',
        fontWeight: '700',
        fontSize: '24.1px',
        color: '#000000',
    },
    header: {
        fontFamily: '"Archivo Expanded", sans-serif',
        fontWeight: '700',
        fontSize: '12.5px',
        color: '#5b595b',
        textAlign: 'center',
        borderBottom: '1px solid #f0f0f0',
        padding: '0.75rem 1.25rem',
    },
    column: {
        fontFamily: '"Archivo Expanded", sans-serif',
        fontWeight: '400',
        fontSize: '12.5px',
        color: '#5b595b',
        textAlign: 'center',
        padding: '0.75rem 1.25rem',
    }
};

export default ListModal;